import { SNGPCState, ActionTypes, Action } from './types';

const INITIAL_STATE: SNGPCState = {
  empresas: [],
  empresaSelecionada: null,
  responsavelSelecionado: null,
  transactionToken: '',
  loading: false,
  error: null,
  currentStep: 1,
};

export default function reducer(state = INITIAL_STATE, action: Action): SNGPCState {
  switch (action.type) {
    case ActionTypes.RESET_STATE:
      return {
        ...INITIAL_STATE,
      };
    case ActionTypes.FETCH_COMPANIES:
      return {
        ...INITIAL_STATE,
        error: null,
        loading: true,
      };
    case ActionTypes.FETCH_COMPANIES_SUCCESS:
      return {
        ...state,
        empresas: action.payload.empresas,
        error: null,
        loading: false,
        currentStep: 2,
        transactionToken: action.payload.transactionToken,
      };
    case ActionTypes.FETCH_COMPANIES_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case ActionTypes.CREATE_USER:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case ActionTypes.CREATE_USER_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case ActionTypes.CREATE_USER_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case ActionTypes.GO_BACK:
      return {
        ...state,
        currentStep: state.currentStep > 1 ? state.currentStep - 1 : state.currentStep,
        error: null,
        loading: false,
      };
    case ActionTypes.HANDLE_SELECTED_COMPANY:
      return {
        ...state,
        empresaSelecionada: action.payload.empresaSelecionada,
        currentStep: 3,
        error: null,
        loading: false,
        responsavelSelecionado: action.payload.responsavelSelecionado,
      };
    default:
      return state;
  }
}
